import {useTranslation} from 'react-i18next'
import {MenuItem} from './MenuItem'
import {useAuth} from '../../../../../app/modules/auth'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {UserMsgCount} from '../../../../../redux/Slice/chatSlice'
import {useEffect} from 'react'
import {MenuInnerWithSub} from './MenuInnerWithSub'

export function LecturerMenu() {
  const {t} = useTranslation()
  const {hasPermission} = useAuth()
  const dispatch = useAppDispatch()
  const {msgCount} = useAppSelector((state) => state.chat)
  const CountMessages = () => {
    dispatch(UserMsgCount())
  }

  useEffect(() => {
    CountMessages()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [msgCount])
  return (
    <>
      {/* <MenuItem title={t('LABEL.MY_PROFILE')} to='/lec/my-profile' /> */}
      {/* <MenuItem title={t('LABEL.MY_COURSES')} to='/lec/my-courses' /> */}

      {/* {hasPermission('publications-list') && (
        <MenuItem title={t('MENU.PUBLICATIONS')} to='/lec/publications-list' />
      )} */}

      <MenuInnerWithSub
        title={t('LABEL.MY_EVALUATIONS')}
        to=''
        menuPlacement='bottom-end'
        menuTrigger='click'
        hasArrow={true}
        fontIcon=''
      >
        <MenuItem
          title={t('LABEL.GENERAL_FACULTY_FEEDBACK')}
          to='/lec/feedback'
          fontIcon='fa-solid fa-comments text-white mx-2'
        />
        <MenuItem
          title={t('LABEL.PEER_EVALUATION')}
          to='/lec/peer-evaluations'
          fontIcon='fa-solid fa-square-poll-vertical text-white mx-2'
        />
      </MenuInnerWithSub>

      {(hasPermission('news-list') ||
        hasPermission('news-archive-list') ||
        hasPermission('email-services')) && (
        <MenuInnerWithSub
          title={t('MENU.COMMUNICATION')}
          to=''
          menuPlacement='bottom-end'
          menuTrigger='click'
          hasArrow={true}
          fontIcon=''
        >
          <div className='menu-item mx-1'>
            {hasPermission('news-list') && (
              <MenuItem
                to='/lec/news-list'
                title={t('MENU.NEWS_AND_ANNOUNCEMENTS')}
                fontIcon='fa fa-envelope text-white mx-2'
              />
            )}
            <MenuItem
              to='/lec/meetings'
              fontIcon='fa fa-calendar text-white mx-2'
              title={t('MEETING.MEETINGS')}
            />
            <a
              href='https://en.swiss-umef.ch/news-universite-geneve-suisse'
              className='menu-link menu-here mx-2'
              target='_blank'
              rel='noopener noreferrer'
            >
              <span className='fa fa-newspaper text-white mx-2 fs-2'></span>
              <span className='menu-title'>{t('LABEL.UMEF_NEWS')}</span>
            </a>
          </div>

          <div className='menu-item mx-1'>
            <a
              href='https://en.swiss-umef.ch/evenements-universite-geneve'
              className='menu-link menu-here mx-2'
              target='_blank'
              rel='noopener noreferrer'
            >
              <span className='fa fa-calendar-alt text-white mx-3 fs-2'></span>
              <span className='menu-title'>{t('LABEL.MY_EVENTS')}</span>
            </a>
          </div>

          <MenuItem
            title={t('LABEL.MY_UMEF')}
            to='/lec/my-umef'
            fontIcon='fa fa-university text-white mx-3'
          />
        </MenuInnerWithSub>
      )}

      {hasPermission('regulations-list') && (
        <MenuItem to='/lec/regulations' title={t('MENU.REGULATIONS')} />
      )}

      <MenuItem
        to='/chat/lec-chat-room'
        title={
          <span className='position-relative'>
            {t('LABEL.CHAT')}
            <span className='badge badge-circle bg-danger position-absolute top-0 text-white translate-middle'>
              {msgCount}
            </span>
          </span>
        }
      />
    </>
  )
}
